import { notify } from "src/services/Notification/Notification"

export default function InboundSingle({ index, setInbound, item, isRefund = false }) {

    const handleChange = (e) => {
        let count = Number(e.target.value);
        if (count > item?.totalQuantity) {
            notify("تعداد تحویل نمیتواند بزرگتر از تعداد فروش باشد", "error");
            count = item?.totalQuantity ?? 0; // اصلاح شد
        }
        setInbound(prev => {
            return prev.map((item, innerIndex) => {
                if (innerIndex === index) {
                    return {
                        ...item,
                        delivaryQuantity: count
                    };
                }
                return item;
            });
        });
    };

    const totalQty = item?.totalQuantity ?? item?.inboundQuantity;
    const delivered = item?.delivaryQuantity ?? totalQty;
    const deficit = totalQty - delivered; // کسری

    return (
        <div className="p-2 flex flex-col lg:flex-row items-center justify-between gap-2 w-full border border-gray-200 rounded-xl">
            <div className="flex flex-col lg:flex-row gap-3 items-center">
                <img
                    className="w-14 border border-gray-100 rounded-xl"
                    src={`${process.env.REACT_APP_CDN_URL}/thumbnail/${item?.productId ?? item?.product_id}/${item?.product?.featuredImage ?? item?.image}`}
                />
                <div className="flex gap-2 items-center">
                    <span className="text-sm">{item?.product?.name ?? item?.name}</span>
                    <span className="text-xs">({item?.product?.sku ?? item?.sku})</span>
                </div>
                <div className="flex gap-2 items-center">
                    <div className="flex gap-1 items-center dark:bg-gray-700 bg-red-50 text-red-700 px-2 py-1 rounded-lg">
                        <span>{totalQty}</span>
                        <span>عدد</span>
                    </div>
                </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-2">
                {deficit > 0 && !isRefund && (
                    <div className="bg-red-50 p-2 !py-1 rounded-xl text-xs text-red-600 flex items-center gap-1">
                        <span>کسری:</span>
                        <span className="text-base font-semibold">{deficit}</span>
                    </div>
                )}
                <div className="flex gap-2 items-center">
                    <span>تعداد تحویل:</span>
                    <input
                        type="number"
                        value={delivered}
                        min={0}
                        max={totalQty}
                        onChange={handleChange}
                        className="border border-gray-200 rounded-lg p-2 w-[90px]"
                    />
                </div>

            </div>
        </div>
    );
}
